import { createLoadingReducer } from './utils';

export default createLoadingReducer('PRICE_VIEW_TYPES');
